import { useState, useRef, useEffect } from "react";
import "font-awesome/css/font-awesome.min.css";
import { Tooltip } from "primereact/tooltip";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import {
  setEmissionBySizeHeightPanel,
  setMapHeightPanel,
  setSurveyCompStatusHeightPanel,
  setSurveyEmissionStackGraph,
} from "../../store/AuraCamera/common";

interface Props {
  InnerComponent: any;
  Heading?: string;
  downloadData?: any;
  gridData?: any;
  tableData?: any;
  activeClass?: any;
}

const RightPanel = (ParaForRightCompEvents: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    InnerComponent,
    Heading,
    downloadData,
    gridData,
    tableData,
    activeClass,
  } = ParaForRightCompEvents;
  var ToolTip: any = Heading;
  if (Heading === "Survey Comple...") {
    ToolTip = "Survey Completion Status";
  } else if (Heading === "Emission by Size") {
    ToolTip = "Emission by Size";
  }
  const [resize_icon, setResizeIcon] = useState("fa-expand");
  const [resize_class, setResizeClass] = useState("");
  const [toggle_icon, setToggleIcon] = useState("fa-chevron-up");
  const [toggle_class, setToggleClass] = useState("");

  const toggle_ref = useRef<any>(null);
  const resize_ref = useRef<any>(null);

  var resizeBlock = (resize_icon_para: any, e: any) => {
    if (resize_icon_para === "fa-expand") {
      setResizeIcon("fa-compress");
      setResizeClass("right-component-to-full-size");
      toggle_ref.current.style.visibility = "hidden";
      if (Heading === "Survey Emission" || Heading === "Emission by Source") {
        dispatch(setSurveyEmissionStackGraph(true as any));
      }
      if (Heading === "Emission Overview" || Heading === "Map" || Heading === "Inspection Overview") {
        dispatch(setMapHeightPanel(true as any));
      }
      if (Heading === "Emission by Size") {
        dispatch(setEmissionBySizeHeightPanel(true as any));
      }
      if (Heading === "Survey Comple...") {
        dispatch(setSurveyCompStatusHeightPanel(true as any));
      }
    } else {
      setResizeIcon("fa-expand");
      setResizeClass("");
      toggle_ref.current.style.visibility = "visible";

      if (Heading === "Survey Emission" || Heading === "Emission by Source") {
        dispatch(setSurveyEmissionStackGraph(false as any));
      }
      if (Heading === "Emission Overview" || Heading === "Map" || Heading === "Inspection Overview") {
        dispatch(setMapHeightPanel(false as any));
      }
      if (Heading === "Emission by Size") {
        dispatch(setEmissionBySizeHeightPanel(false as any));
      }
      if (Heading === "Survey Comple...") {
        dispatch(setSurveyCompStatusHeightPanel(false as any));
      }
    }
  };

  var toogleBlock = (toggle_icon_para: any, e: any) => {
    if (toggle_icon_para === "fa-chevron-up") {
      setToggleIcon("fa-chevron-down");
      setToggleClass("right-component-to-toggle");
      resize_ref.current.style.visibility = "hidden";
    } else {
      setToggleIcon("fa-chevron-up");
      setToggleClass("");
      resize_ref.current.style.visibility = "visible";
    }
  };

  const downloadExcelData = (event: any) => {
    downloadData();
  };

  return (
    <>
      <div className={`${resize_class} mb-4`}>
        <div className="panel_div">
          <Tooltip target=".common_panel_heading_test" />
          {Heading && (
            <span
              className="common_panel_heading_test"
              data-pr-tooltip={ToolTip}
              data-pr-position="top"
              data-pr-at="right+5 top"
              data-pr-my="left center-2"
              style={{ fontSize: "4rem" }}
            >
              {Heading}
              <span>
                {Heading == "Max leak" && (
            <label className="top20label" data-i18n="Dashboard.TopTwenty">
              Top 10
            </label>
          )}
              </span>
            </span>
          )}

          {/* {Heading == "Emission by Source" && (
            <label className="top20label" data-i18n="Dashboard.TopTwenty">
              Top 20
            </label>
          )} */}
          <div className="panel_icon_div">
            {/* onClick={(e) => downloadExcelData(e)} */}

            {gridData && (
              <i
                title="Card form"
                className={`pi pi-credit-card custom-fa-icon-style fs-5 me-3 ${activeClass.gridActive}`}
                onClick={() => gridData(true)}
              ></i>
            )}
            {tableData && (
              <i
              title="Table form"
                className={`pi pi-table custom-fa-icon-style fs-5 me-3 ${activeClass.tableActive}`}
                onClick={() => tableData(false)}
              ></i>
            )}
            {downloadData && (
              <i
              title="Export to excel"
                className={`fa fa-file-excel-o custom-fa-icon-style fs-5 me-3`}
                onClick={downloadData}
              ></i>
            )}
            <i
              title="Toggle component"
              className={`fa ${toggle_icon} custom-fa-icon-style fs-5 me-3`}
              ref={toggle_ref}
              onClick={(e) => toogleBlock(toggle_icon, e)}
            ></i>
            <i
             title="Resize component"
              className={`fa ${resize_icon} custom-fa-icon-style fs-5`}
              ref={resize_ref}
              onClick={(e) => resizeBlock(resize_icon, e)}
            ></i>
          </div>
        </div>

        <div className={`${toggle_class} card-body`}>{InnerComponent}</div>
      </div>
    </>
  );
};

export default RightPanel;
